import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_vtsl/helpers';
import { useEffect,useState } from 'react';
const Error404 = () => {
  const [showLogout, setShowLogout] = useState(false);

  useEffect(() => {

    const showLogout = localStorage.getItem('ShowLogout')
    setShowLogout(showLogout)


  }, []);
  return (<div className='d-flex flex-column flex-root'>
    <div className='d-flex flex-column flex-center flex-column-fluid p-10'>
      {/* begin::Illustration */}
      <img src={toAbsoluteUrl('/media/illustrations/sketchy-1/18.png')} alt='' className='mw-100 mb-10 h-lg-450px' />

      <h1 className='fw-bold mb-10' style={{ color: '#A3A3C7' }}>
        Seems there is nothing here
      </h1>

      {!showLogout ? <Link to='/' className='btn primary-button-New'>
        Return Home
      </Link> : <Link to='/userManagemnet' className='btn primary-button-New'>
        Return User Management
      </Link>
      }
    </div>
  </div>);
};
export { Error404 };
